import abCreativeIcon from '../assets/icons/ab-creative.svg'
import betaTestRecruitingIcon from '../assets/icons/beta-test-recruiting.svg'
import featurePrioritizationIcon from '../assets/icons/feature-prioritization.svg'
import npsIcon from '../assets/icons/nps.svg'
import packageDesignIcon from '../assets/icons/package-design.svg'
import postPurchaseIcon from '../assets/icons/post-purchase.svg'
import priceSensitivityIcon from '../assets/icons/price-sensitivity.svg'
import valuePropositionIcon from '../assets/icons/value-proposition.svg'

/** Keys match `instrument_templates.iconKey` in campaign-service seed data (Figma handoff). */
export type InstrumentTemplateIconKey =
  | 'ab-creative'
  | 'package-design'
  | 'price-sensitivity'
  | 'value-proposition'
  | 'nps'
  | 'post-purchase'
  | 'feature-prioritization'
  | 'beta-test-recruiting'

type TemplateIconDefinition = {
  tileBg: string
  iconSrc: string
  /** Slightly larger glyph when the art reads smaller at default size (e.g. tall medal). */
  glyphScale?: number
}

const REGISTRY: Record<InstrumentTemplateIconKey, TemplateIconDefinition> = {
  'ab-creative': { tileBg: '#dbeafe', iconSrc: abCreativeIcon },
  'package-design': { tileBg: '#f3e8ff', iconSrc: packageDesignIcon },
  'price-sensitivity': { tileBg: '#dcfce7', iconSrc: priceSensitivityIcon },
  'value-proposition': {
    tileBg: '#ccfbf1',
    iconSrc: valuePropositionIcon,
    glyphScale: 1.15,
  },
  nps: { tileBg: '#ffedd5', iconSrc: npsIcon },
  'post-purchase': { tileBg: '#fce7f3', iconSrc: postPurchaseIcon },
  'feature-prioritization': { tileBg: '#e0f2fe', iconSrc: featurePrioritizationIcon },
  'beta-test-recruiting': { tileBg: '#e0e7ff', iconSrc: betaTestRecruitingIcon },
}

const FALLBACK: TemplateIconDefinition = REGISTRY['ab-creative']

export function resolveTemplateIcon(iconKey: string): TemplateIconDefinition {
  if (iconKey in REGISTRY) {
    return REGISTRY[iconKey as InstrumentTemplateIconKey]
  }
  return FALLBACK
}
